import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../../atoms/button'
import { Title, Text } from '../../atoms/text'

import { StyledConfirmationModalWrapper, StyledTextWrapper } from './styles'
import { useModalContext } from '../../../context/modalProvider'

const ConfirmationModal = (props) => {
  const { close, title } = useModalContext()
  const {
    img,
    subtitle,
    text,
    onConfirmation,
    onCancel,
    confirmButtonText = 'Confirm',
    cancelButtonText = 'Cancel',
    keepModalOpen = false,
  } = props

  return (
    <StyledConfirmationModalWrapper>
      <StyledTextWrapper>
        {title && <Title level={2}>{title}</Title>}
        {img && <img src={img} />}
        {subtitle && <Title level={2}>{subtitle}</Title>}
        {text && <Text>{text}</Text>}
      </StyledTextWrapper>
      <Button
        minWidth="140px"
        onClick={(e) => {
          onConfirmation?.(e)
          if (!keepModalOpen) {
            close()
          }
        }}
      >
        {confirmButtonText}
      </Button>
      <Button
        bordered
        dark
        minWidth="140px"
        onClick={(e) => {
          onCancel?.(e)
          close()
        }}
      >
        {cancelButtonText}
      </Button>
    </StyledConfirmationModalWrapper>
  )
}

ConfirmationModal.propTypes = {
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  img: PropTypes.string,
  keepModalOpen: PropTypes.bool,
  onConfirmation: PropTypes.func,
  onCancel: PropTypes.func,
  subtitle: PropTypes.string,
  text: PropTypes.string,
}

export { ConfirmationModal }
